import Koppa from "@koppajs/koppajs-core";

// home
import homeView from "~/components/pages/home/home-view.kpa";
Koppa.take(homeView, 'home-view');


// ueberuns
import ueberunsView from "~/components/pages/ueberuns/ueberuns-view.kpa";
Koppa.take(ueberunsView, 'ueberuns-view');

import fachkompetenzView from "~/components/pages/ueberuns/fachkompetenz/fachkompetenz-view.kpa";
Koppa.take(fachkompetenzView, 'fachkompetenz-view');

import infrastrukturView from "~/components/pages/ueberuns/infrastruktur/infrastruktur-view.kpa";
Koppa.take(infrastrukturView, 'infrastruktur-view');

import automatisierungView from "~/components/pages/ueberuns/automatisierung/automatisierung-view.kpa";
Koppa.take(automatisierungView, 'automatisierung-view');

import objektakteView from "~/components/pages/ueberuns/objektakte/objektakte-view.kpa";
Koppa.take(objektakteView, 'objektakte-view');


// leistungen
import objektpflegeView from "~/components/pages/leistungen/objektpflege/objektpflege-view.kpa";
Koppa.take(objektpflegeView, 'objektpflege-view');

import hausmeisterServiceView from "~/components/pages/leistungen/hausmeisterservice/hausmeisterservice-view.kpa";
Koppa.take(hausmeisterServiceView, 'hausmeisterservice-view');

import instandhaltungView from "~/components/pages/leistungen/instandhaltung/instandhaltung-view.kpa";
Koppa.take(instandhaltungView, 'instandhaltung-view');


// referenzen
import referenzenView from "~/components/pages/referenzen/referenzen-view.kpa";
Koppa.take(referenzenView, 'referenzen-view');


// rechtliches
import impressumView from "~/components/pages/impressum/impressum-view.kpa";
Koppa.take(impressumView, 'impressum-view');

import datenschutzerklaerungView from "~/components/pages/datenschutzerklaerung/datenschutzerklaerung-view.kpa";
Koppa.take(datenschutzerklaerungView, 'datenschutzerklaerung-view');

import agbsView from "~/components/pages/agbs/agbs-view.kpa";
Koppa.take(agbsView, 'agbs-view');

import widerrufsbelehrungView from "~/components/pages/widerrufsbelehrung/widerrufsbelehrung-view.kpa";
import { Route } from "./types";
Koppa.take(widerrufsbelehrungView, 'widerrufsbelehrung-view');


import { defaultTitle, defaultDescription } from "./metadata";

const websiteTitle = 'FASE2 Facility Services';

const routes: Route[] = [
    {
        path: '/',
        component: 'home-view',
        name: 'root',
        meta: {
            label: 'Home',
            requiresAuth: false,
            title: defaultTitle,
            description: defaultDescription,
            keywords: 'Facility Service, Gebäudereinigung, Hausmeisterservice, Grünpflege, Graupflege, Reinigungsdienst, professionelle Dienstleistungen',
        },
    },
    {
        path: '/home',
        component: 'home-view',
        name: 'home',
        meta: {
            label: 'Home',
            requiresAuth: false,
            title: defaultTitle,
            description: defaultDescription,
            keywords: 'Facility Service, Gebäudemanagement, Hausmeisterdienste, Reinigungsservice, Grünpflege, Graupflege',
        },
    },
    {
        path: '/ueberuns',
        component: 'ueberuns-view',
        name: 'ueberuns',
        meta: {
            label: 'Über Uns',
            requiresAuth: false,
            title: `Über Uns - ${websiteTitle}`,
            description: 'Erfahren Sie mehr über unser Unternehmen, unsere Mission und unser engagiertes Team im Bereich Facility Services.',
            keywords: 'Über uns, Facility Service, Team, Unternehmensmission, Gebäudemanagement',
            redirectToChild: 'fachkompetenz',
        },
        children: [
            {
                path: 'fachkompetenz',
                component: 'fachkompetenz-view',
                name: 'fachkompetenz',
                meta: {
                    label: 'Fachkompetenz',
                    requiresAuth: false,
                    title: `Fachkompetenz - ${websiteTitle}`,
                    description: 'FASE2: Zuverlässige und professionelle Immobilienpflege. Über 38 Jahre Erfahrung in Sanierung und Gebäudereinigung. Ihr Partner für nachhaltige Instandhaltung.',
                    keywords: 'Immobilienpflege, Gebäudereinigung, Sanierung, zuverlässiger Service, professionelle Instandhaltung, FASE2',
                },
            },
            {
                path: 'infrastruktur',
                component: 'infrastruktur-view',
                name: 'infrastruktur',
                meta: {
                    label: 'Infrastruktur',
                    requiresAuth: false,
                    title: `Infrastruktur - ${websiteTitle}`,
                    description: 'Das FASE2-Netzwerk: Fachpartner, gebündelte Ressourcen und abgestimmte Abläufe für die Betreuung Ihrer Immobilie in Köln und Umgebung.',
                    keywords: 'Grünpflege, Gartenpflege, Rasenpflege, Baumpflege, Außenanlagen',
                },
            },
            {
                path: 'automatisierung',
                component: 'automatisierung-view',
                name: 'automatisierung',
                meta: {
                    label: 'Automatisierung',
                    requiresAuth: false,
                    title: `Automatisierung - ${websiteTitle}`,
                    description: 'FASE2 setzt auf digitale Auftragsabwicklung und automatisierte Prozesse für transparente Abläufe bei der Betreuung Ihrer Immobilie.',
                    keywords: 'Grünpflege, Gartenpflege, Rasenpflege, Baumpflege, Außenanlagen',
                },
            },
            {
                path: 'objektakte',
                component: 'objektakte-view',
                name: 'objektakte',
                meta: {
                    label: 'Objektakte',
                    requiresAuth: false,
                    title: `Objektakte - ${websiteTitle}`,
                    description: 'Die digitale Objektakte von FASE2 bündelt Leistungsanforderungen, Dokumentation und individuelle Konzepte für Ihre Immobilie.',
                    keywords: 'Grünpflege, Gartenpflege, Rasenpflege, Baumpflege, Außenanlagen',
                },
            },
        ],
    },
    {
        path: '/leistungen',
        component: 'leistungen-view',
        name: 'leistungen',
        meta: {
            label: 'Leistungen',
            requiresAuth: false,
            title: `Leistungen - ${websiteTitle}`,
            description: 'Entdecken Sie unser breites Leistungsspektrum: Von Grünpflege über Reinigungsdienste bis hin zum Hausmeisterservice.',
            keywords: 'Leistungen, Facility Service, Gebäudereinigung, Grünpflege, Reinigungsdienst, Hausmeisterservice',
            redirectToChild: 'objektpflege',
        },
        children: [
            {
                path: 'objektpflege',
                component: 'objektpflege-view',
                name: 'objektpflege',
                meta: {
                    label: 'Objektpflege',
                    requiresAuth: false,
                    title: `Objektpflege - ${websiteTitle}`,
                    description: 'Professionelle, nachhaltige Objektpflege mit FASE2 – für saubere, gepflegte und langfristig wertvolle Immobilien.',
                    keywords: 'Objektpflege, Rasenpflege, Gebäudereinigung, Gartenservice, Fassadenreinigung',
                },
            },
            {
                path: 'hausmeisterservice',
                component: 'hausmeisterservice-view',
                name: 'hausmeisterservice',
                meta: {
                    label: 'Hausmeisterservice',
                    requiresAuth: false,
                    title: `Hausmeisterservice - ${websiteTitle}`,
                    description: 'Zuverlässiger Hausmeisterservice mit FASE2 – für Pflege, Instandhaltung und Verwaltung Ihrer Immobilie aus einer Hand.',
                    keywords: 'Hausmeisterservice, Gebäudepflege, Winterdienst, Objektkontrolle, Abfallmanagement',
                },
            },
            {
                path: 'instandhaltung',
                component: 'instandhaltung-view',
                name: 'instandhaltung',
                meta: {
                    label: 'Instandhaltung',
                    requiresAuth: false,
                    title: `Instandhaltung - ${websiteTitle}`,
                    description: 'Professionelle Instandhaltung mit FASE2 – für Werterhalt, Hygiene und nachhaltige Pflege Ihrer Immobilie.',
                    keywords: 'Instandhaltung, Zustandsüberwachung, Fugenpflege, Gebäudesanierung, Werterhalt',
                },
            },
        ],
    },
    {
        path: '/referenzen',
        component: 'referenzen-view',
        name: 'referenzen',
        meta: {
            label: 'Referenzen',
            requiresAuth: false,
            title: `Referenzen - ${websiteTitle}`,
            description: 'Werfen Sie einen Blick auf unsere Referenzen und überzeugen Sie sich von unserer Kompetenz im Facility Management.',
            keywords: 'Referenzen, Projekte, Facility Management, Kundenbewertungen, Erfolgsgeschichten',
        },
    },
    {
        path: '/impressum',
        component: 'impressum-view',
        name: 'impressum',
        meta: {
            label: 'Impressum',
            requiresAuth: false,
            title: `Impressum - ${websiteTitle}`,
            description: 'Rechtliche Informationen und Kontaktdetails unseres Facility Service Unternehmens.',
            keywords: 'Impressum, rechtliche Informationen, Kontakt, Anbieterkennzeichnung',
        },
    },
    {
        path: '/datenschutzerklaerung',
        component: 'datenschutzerklaerung-view',
        name: 'datenschutzerklaerung',
        meta: {
            label: 'Datenschutzerklärung',
            requiresAuth: false,
            title: `Datenschutzerklärung - ${websiteTitle}`,
            description: 'Erfahren Sie mehr über unsere Datenschutzerklärung und den Schutz Ihrer Daten.',
            keywords: 'Datenschutzerklärung, Datenschutz, Datenschutzrichtlinien, Datensicherheit, persönliche Daten',
        },
    },
    {
        path: '/agbs',
        component: 'agbs-view',
        name: 'agbs',
        meta: {
            label: 'AGB\'s',
            requiresAuth: false,
            title: `AGB's - ${websiteTitle}`,
            description: 'Unsere allgemeinen Geschäftsbedingungen für Dienstleistungen im Bereich Facility Management.',
            keywords: 'AGBs, Geschäftsbedingungen, Facility Management, Dienstleistungen',
        },
    },
    {
        path: '/widerrufsbelehrung',
        component: 'widerrufsbelehrung-view',
        name: 'widerrufsbelehrung',
        meta: {
            label: 'Widerrufsbelehrung',
            requiresAuth: false,
            title: `Widerrufsbelehrung - ${websiteTitle}`,
            description: 'Informationen zum Widerrufsrecht und zur Ausübung des Widerrufs bei FASE2 Facility Services.',
            keywords: 'Widerrufsbelehrung, Widerrufsrecht, Rückgaberecht, Verbraucherschutz, Vertrag widerrufen, Widerrufsrecht Informationen, Widerrufserklärung',
        },
    },
];

export default routes;